import { render, staticRenderFns } from "./down.vue?vue&type=template&id=da414360&scoped=true&"
import script from "./down.vue?vue&type=script&lang=js&"
export * from "./down.vue?vue&type=script&lang=js&"
import style0 from "./down.vue?vue&type=style&index=0&id=da414360&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da414360",
  null
  
)

export default component.exports